// import { combineReducers } from "redux";
import { RenderList } from "./renderListReducesr";

// const RenderListReducers = combineReducers({
//   RenderList,
// });

export default RenderList;
